<template>
    <div data-component="GroupBookingToggle"
         class="group-booking-toggle">
        <Toggle name="group-booking"
                :model-value="enabled"
                :disabled="locked"
                label="SELL.GROUP_BOOKING_TOGGLE"
                @update:model-value="changeValue" />
    </div>
</template>

<script>
import Toggle from '@/vue/components/Forms/Toggle';
import { container } from '@/container';

export default {
    components: {
        Toggle,
    },

    data() {
        return {
            /**
             * This is controlled by the watcher that checks the current cart's value.
             *
             * @type {boolean}
             */
            enabled: false,

            /**
             * If there are any group references in the cart the user should not be able to un-mark the order
             * as a group booking.
             */
            locked: false,
        };
    },

    watch: {
        '$store.state.cart.modified': {
            handler() {
                this.enabled = container.cartService.currentCart.groupBooking;
                this.locked = container.cartService.currentCart.itemList.some((line) => !!line.groupBookingReference);
            },
            immediate: true,
        },
    },

    methods: {
        async changeValue(newValue) {
            await container.cartService.setGroupBooking(newValue, true);
        },
    },
};
</script>

<style lang="less">
@import "../../../../less/variables.less";

.group-booking-toggle {
    background: @light-grey-alt; // 5% black
    border-radius: @border-radius-base;
    margin-bottom: @half-gutter-width;
    padding: @gutter-width-narrow;

    .toggle--label-before input + label {
        justify-content: space-between;
    }

    .toggle input + label {
        font-size: @font-size-medium;
    }
}
</style>
